import { render, staticRenderFns } from "./multiselect.html?vue&type=template&id=3db3975a&scoped=true&"
import script from "./multiselect.js?vue&type=script&lang=js&"
export * from "./multiselect.js?vue&type=script&lang=js&"
import style0 from "./multiselect.scss?vue&type=style&index=0&id=3db3975a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db3975a",
  null
  
)

export default component.exports